export { FotogalerieProps } from './fotogalerie.props';
export const name = "FotogalerieComponent";
